"use client";

import { useEffect } from "react";
import { prefetchCsrfToken } from "@repo/shared-utils/csrfToken";

const LoadCSRFToken = () => {
  useEffect(() => {
    prefetchCsrfToken();
  }, []);
  return null;
};

export default LoadCSRFToken;
